import type { BackendRouteDefinition } from '../types';

export const addInvoiceTransactionAllocationRoute = {
  body: (request: {
    amountCents: number;
    invoiceId: string;
    transactionId: string;
  }) => request,
  method: 'POST',
  path: '/firms/invoice-allocations',
  transport: 'api',
} as const satisfies BackendRouteDefinition;

export const changeInvoiceTransactionAllocationRoute = {
  body: (request: {
    amountCents: number;
    invoiceId: string;
    transactionId: string;
  }) => request,
  method: 'PATCH',
  path: '/firms/invoice-allocations',
  transport: 'api',
} as const satisfies BackendRouteDefinition;

export const releaseInvoiceTransactionAllocationRoute = {
  body: (request: { invoiceId: string; transactionId: string }) => request,
  method: 'DELETE',
  path: '/firms/invoice-allocations',
  transport: 'api',
} as const satisfies BackendRouteDefinition;
